import React, { Fragment } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import { Button } from "@mui/material";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeCheckout = ({
  product,
  fullwith = false,
  variant = "contained",
  color = "primary",
  hasIcon = true,
  noLogin = true,
}) => {
  const handleCheckout = async () => {

    const stripe = await stripePromise;
    let response = null
    try {
      if (noLogin) {
        response = await callBackendApi(
          "create-checkout-session-without-login",
          "POST",
          {
            id: product.id,
          }
        );
      } else {
        response = await callBackendApi(
          "create-checkout-session",
          "POST",
          {
            id: product.id,
          }
        );
      }
      const sessionId = response.data.id;

      // Redirect to Stripe's hosted checkout page
      const { error } = await stripe.redirectToCheckout({ sessionId });

      if (error) console.error("Stripe checkout error:", error);
    } catch (err) {
      console.error("Error creating checkout session:", err);
    }
  };

  return (
    <Fragment>
      <Button
        variant={variant}
        color={color}
        size="large"
        fullWidth={fullwith}
        sx={{ minWidth: "fit-content" }}
        style={{ marginRight: "auto", marginLeft: "auto" }}
        onClick={handleCheckout}
      >
        Get Launch Core {hasIcon ? "🖥️" : null}
      </Button>
    </Fragment>
  );
};

export default StripeCheckout;
